import gql from 'graphql-tag'

export const QUERY_RAFFLES_LIST = gql`
  query RafflesList($page: Int!, $pageSize: Int!, $search: String, $status: [RaffleStatus], $sort: [String], $sortDirection: [SortDirection]) {
    rafflesList(page: $page, pageSize: $pageSize, status: $status, search: $search, sort: $sort, sortDirection: $sortDirection) {
      rafflesList {
        _id
        start_date
        end_date
        on_approval
        rules {
          type
          value
          acceleration_operation
          acceleration_value
          products {
            sku
            name
            ean
          }
          product_groups {
            uuid
            active
            name
            image_url
            trigger_value
            acceleration_value
            max_per_coupon_value
          }
        }
        prizes {
          _id
          title
          image_url
          given
          raffle_date
          eligibility_start_date
          eligibility_end_date
          quantity
          winners {
            _id
            lucky_number {
              unit {
                id_erp
                name
              }
              coupon_id
              number
              created_at
              coupon_created_at
            }
            user {
              _id
              id_erp
              name
              document_no
            }
            prize_given
            notifications {
              sent_at
              message
              channels
            }
          }
        }
        units {
          id_erp
          name
        }
        draft
        title
        status
        description
        app_description
        app_start_exhibition_date
        app_end_exhibition_date
        register_number
        max_numbers_per_person
        max_numbers_per_coupon
        banner_url
        rules_url
        optin {
          active
          terms
        }
        created_at
        updated_at
      }
      records
      page
    }
  }
`
export const QUERY_RAFFLE_BY_ID = gql`
  query GetRaffleById($raffle_id: ID!) {
    getRaffleById(raffle_id: $raffle_id) {
      _id
      start_date
      end_date
      available_in_app
      on_approval
      segments {
        _id
        name
        clients_qty
      }
      exclusion_segments {
        _id
        name
        clients_qty
      }
      rules {
        type
        value
        cumulative
        acceleration_operation
        acceleration_value
        products {
          sku
          name
          ean
        }
        product_groups {
          uuid
          active
          name
          image_url
          trigger_value
          acceleration_value
          max_per_coupon_value
          products {
            sku
            name
            ean
          }
        }
      }
      prizes {
        _id
        title
        image_url
        given
        raffle_date
        eligibility_start_date
        eligibility_end_date
        quantity
        winners {
          _id
          lucky_number {
            unit {
              id_erp
              name
            }
            coupon_id
            number
            created_at
            coupon_created_at
          }
          user {
            _id
            id_erp
            name
            document_no
          }
          prize_given
          notifications {
            sent_at
            message
            channels
          }
        }
      }
      units {
        id_erp
        name
      }
      draft
      title
      status
      description
      app_description
      app_start_exhibition_date
      app_end_exhibition_date
      register_number
      max_numbers_per_person
      max_numbers_per_coupon
      banner_url
      rules_url
      optin {
        active
        terms
      }
      created_at
      updated_at
      min_series
      max_series
      lucky_number_generation_type
    }
  }
`
export const QUERY_RAFFLE_ON_APPROVAL_BY_ID = gql`
  query GetRaffleOnApprovalById($raffle_id: ID!) {
    getRaffleOnApprovalById(raffle_id: $raffle_id) {
      _id
      start_date
      end_date
      available_in_app
      on_approval
      segments {
        _id
        name
        clients_qty
      }
      exclusion_segments {
        _id
        name
        clients_qty
      }
      rules {
        type
        value
        cumulative
        acceleration_operation
        acceleration_value
        products {
          sku
          name
          ean
        }
        product_groups {
          uuid
          active
          name
          image_url
          trigger_value
          acceleration_value
          max_per_coupon_value
          products {
            sku
            name
            ean
          }
        }
      }
      prizes {
        _id
        title
        image_url
        given
        raffle_date
        eligibility_start_date
        eligibility_end_date
        quantity
        winners {
          _id
          lucky_number {
            unit {
              id_erp
              name
            }
            coupon_id
            number
            created_at
            coupon_created_at
          }
          user {
            _id
            id_erp
            name
            document_no
          }
          prize_given
          notifications {
            sent_at
            message
            channels
          }
        }
      }
      units {
        id_erp
        name
      }
      draft
      title
      status
      description
      app_description
      app_start_exhibition_date
      app_end_exhibition_date
      register_number
      max_numbers_per_person
      max_numbers_per_coupon
      banner_url
      rules_url
      optin {
        active
        terms
      }
      created_at
      updated_at
      min_series
      max_series
      lucky_number_generation_type
    }
  }
`
export const QUERY_RAFFLE_PARTICIPANTS = gql`
  query RaffleParticipants($raffle_id: ID!, $search: String) {
    raffleParticipants(raffle_id: $raffle_id, search: $search) {
      raffleParticipants {
        user {
          _id
          id_erp
          name
          document_no
        }
        lucky_number {
          unit {
            id_erp
            name
          }
          coupon_id
          coupon_value
          number
          created_at
          coupon_created_at
        }
      }
    }
  }
`

export const QUERY_PAGINATED_RAFFLE_PARTICIPANTS = gql`
  query RaffleParticipants($raffle_id: ID!, $search: String, $pageSize: Int, $page: Int, $sort: [String], $sortDirection: [SortDirection]) {
    raffleParticipants(raffle_id: $raffle_id, search: $search, pageSize: $pageSize, page: $page, sort: $sort, sortDirection: $sortDirection) {
      records
      page
      raffleParticipants {
        user {
          _id
          id_erp
          name
          document_no
        }
        lucky_number {
          unit {
            id_erp
            name
          }
          coupon_id
          coupon_value
          number
          created_at
          coupon_created_at
        }
      }
    }
  }
`
export const QUERY_LUCKY_NUMBERS_METRICS = gql`
  query RaffleLuckyNumbersMetrics($raffleId: ID!) {
    raffleLuckyNumbersMetrics(raffle_id: $raffleId) {
      total_lucky_numbers
      last_lucky_number
      first_lucky_number
    }
  }
`
export const MUTATION_CREATE_RAFFLE = gql`
  mutation UpsertRaffleCampaign($raffle: RaffleCampaignInput!) {
    upsertRaffleCampaign(raffle: $raffle) {
      _id
      message
    }
  }
`
export const MUTATION_CREATE_RAFFLE_APPROVAL = gql`
  mutation UpsertRaffleaPPROVALCampaign($raffle: RaffleCampaignInput!) {
    upsertRaffleApprovalCampaign(raffle: $raffle) {
      _id
      message
    }
  }
`
export const MUTATION_CREATE_RAFFLE_DRAFT = gql`
  mutation UpsertRaffleDraftCampaign($raffle: RaffleDraftCampaignInput!) {
    upsertRaffleDraftCampaign(raffle: $raffle) {
      _id
      message
    }
  }
`
export const MUTATION_DELETE_RAFFLE_DRAFT = gql`
  mutation DeleteRaffle($raffle_id: String!) {
    deleteRaffle(raffle_id: $raffle_id) {
      raffle_id
      message
    }
  }
`
export const MUTATION_CLONE_RAFFLE = gql`
  mutation CloneRaffle($raffle_id: String!) {
    cloneRaffle(raffle_id: $raffle_id) {
      _id
      message
    }
  }
`
export const MUTATION_UPSERT_RAFFLE_WINNERS = gql`
  mutation UpsertWinners($raffleId: ID!, $prizeId: ID!, $winners: [RaffleWinnerInput!]!) {
    upsertWinners(raffle_id: $raffleId, prize_id: $prizeId, winners: $winners)
  }
`

export const SEND_RAFFLE_PARTICIPANTS_LIST_EMAIL = gql`
  mutation CreateRaffleParticipantsReport($raffleId: ID!, $emails: [String!]!, $fileFormat: FileFormatType) {
    createRaffleParticipantsReport(raffleId: $raffleId, emails: $emails, fileFormat: $fileFormat) {
      id
      fileUrl
      state
      payload {
        emails
        raffleId
      }
    }
  }
`

export const MANUALLY_GENERATE_RAFFLE_LUCKY_NUMBERS = gql`
  mutation ManuallyGenerateRaffleLuckyNumbers(
    $raffle_id: ID!
    $document_no: String!
    $lucky_numbers_amount: Int!
    $unit_id: String!
    $coupon_number: String!
    $coupon_image_link: String!
    $force: Boolean
  ) {
    manuallyGenerateRaffleLuckyNumbers(
      raffle_id: $raffle_id
      document_no: $document_no
      lucky_numbers_amount: $lucky_numbers_amount
      unit_id: $unit_id
      coupon_number: $coupon_number
      coupon_image_link: $coupon_image_link
      force: $force
    ) {
      lucky_numbers {
        unit {
          _id
          id_erp
          name
          address
          mobile
        }
        coupon_id
        coupon_value
        number
      }
    }
  }
`

export const QUERY_DRAW_RAFFLE_WINNERS = gql`
  query DrawRaffleWinners(
    $raffle_id: ID!
    $prize_id: ID!
    $number_of_winners: Int!
    $exclude_past_winners: Boolean
    $number_search_mode: RaffleWinnerSearchMode!
    $series_search_mode: RaffleWinnerSearchMode!
    $secap_number: String!
  ) {
    drawRaffleWinners(
      raffle_id: $raffle_id
      prize_id: $prize_id
      number_of_winners: $number_of_winners
      exclude_past_winners: $exclude_past_winners
      number_search_mode: $number_search_mode
      series_search_mode: $series_search_mode
      secap_number: $secap_number
    ) {
      raffle_id
      prize_id
      draw_winners {
        user {
          _id
          name
          document_no
          id_erp
        }
        lucky_number {
          unit {
            _id
            id_erp
            name
            address
            mobile
          }
          coupon_id
          coupon_value
          created_at
          number
        }
      }
    }
  }
`
